import type {
    IRepository,
    IRepositoryContainer,
} from "@/wc/registry/lib/service/repository/types";

// Allows you to use a RegExp to be able to find repositories that target a
// path matching that exact RegExp. Makes it easier to find repositories
// when you don't know exactly how the variables in paths are named.
//
// E.g. when a repository targets /people/{person_id}/punch, but you
// only know about /people/62/punch, you can create a regex to be able to
// find that same repository.
export function findRepositoriesTargetingPathUsingMethod(
    source: IRepositoryContainer,
    path: RegExp,
    method: string
): IRepository[] {
    return Object.entries(source)
        .filter(([, repo]) => {
            if (!("actionPaths" in repo)) {
                return false;
            }

            return Object.values(repo.actionPaths).some((actionPath) => {
                if (!("path" in actionPath)) {
                    return false;
                }

                if (!("method" in actionPath)) {
                    return false;
                }

                if (actionPath.method !== method) {
                    return false;
                }

                return path.test(actionPath.path);
            });
        })
        .map(([, repo]) => repo);
}

// Allows you to use a string to be able to find repositories that target a
// path with the same length as the given path. Makes it easier to find
// repositories when you don't know exactly how the variables in paths are
// named.
export function findRepositoriesWithSameLengthPathUsingMethod(
    source: IRepositoryContainer,
    path: string,
    method: string
): IRepository[] {
    const length = path.split("/").length;

    return Object.entries(source)
        .filter(([, repo]) => {
            if (!("actionPaths" in repo)) {
                return false;
            }

            return Object.values(repo.actionPaths).some((actionPath) => {
                if (!("path" in actionPath)) {
                    return false;
                }

                if (!("method" in actionPath)) {
                    return false;
                }

                if (actionPath.method !== method) {
                    return false;
                }

                return actionPath.path.split("/").length === length;
            });
        })
        .map(([, repo]) => repo);
}
